import React, { useEffect, useState } from "react";
import { NavbarLinks } from "../../data/navbar-links";
import { Link, matchPath } from "react-router-dom";
import logo from "../../assets/Logo/Logo-Full-Light.png";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { AiOutlineShoppingCart } from "react-icons/ai";
import ProfileDropDown from "../core/Auth/ProfileDropDown";
import { categories } from "../../services/apis";
import { apiConnector } from "../../services/apiconnector";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";

function Navbar(props) {
  const { token } = useSelector((state) => state.auth);
  const { user } = useSelector((state) => state.profile);
  const { totalItems } = useSelector((state) => state.cart);

  const location = useLocation();

  const matchRoute = (route) => {
    return matchPath({ path: route }, location.pathname);
  };

  // const subLinks = [
  //   {
  //     title: "Python",
  //     link: "/catalog/python",
  //   },
  //   {
  //     title: "Web dev",
  //     link: "/catalog/web-development",
  //   },
  // ];

  const [subLinks,setSubLinks] = useState([]);

  async function fetchSubLinks() {
      try
      {
          const result = await apiConnector("GET",categories.CATEGORIES_API)
          // console.log("Printing sublinks result: ",result);
          setSubLinks(result.data.allCategory);
      }
      catch(e)
      {
          console.log("Error while fetch the category list");
      }
  }

  useEffect(()=>{
    console.log(token)
  fetchSubLinks();
  },[])

  return (
    <div className="flex h-14 bg-richblack-800 items-center justify-center border-b-[1px] border-richblack-700">
      <div className="flex w-11/12 max-w-maxContent items-center justify-between">
        {/* Logo */}
        <Link to="/">
          <img
            width={160}
            height={42}
            loading="lazy"
            src={logo}
            alt="StudyNotionLogo"
          />
        </Link>

        {/* Nav Links */}
        <nav>
          <ul className="flex gap-x-6 max-[450px]:hidden text-richblack-5-25">
            {NavbarLinks && Array.isArray(NavbarLinks) && NavbarLinks.map((element, index) => {
              return (
                <li className="text-white" key={index}>
                  {element.title === "Catalog" ? (
                    <div className="flex items-center relative gap-x-1 group">
                      <p>
                        {element.title}
                      </p>
                      <MdOutlineKeyboardArrowDown/>

                      <div className="invisible z-10 absolute left-[50%] top-12 translate-x-[-50%]  flex flex-col rounded-md bg-richblack-5 p-4 text-richblack-900 opacity-0 transition-all duration-200 group-hover:visible group-hover:opacity-100 lg:w-[15rem]">

                      <div className="absolute left-[50%] top-0 translate-y-[-40%] translate-x-5 h-6 w-6 rotate-45 rounded-md bg-richblack-5"></div>
                        {
                          subLinks.length ? (
                              subLinks.map((subLink,index) =>{
                                return (
                                  <Link to={`/catalog/${subLink.name
                                    .split(" ")
                                    .join("-")
                                    .toLowerCase()}`}
                                  // to={`${subLink.link}`}
                                  key={index}>
                                    <p className="text-md font-medium py-4">{subLink.name}</p>
                                  </Link>
                                )
                              })
                          ) : (<div></div>)
                        }
                      </div>
                    </div>
                  ) : (
                    <Link to={`${element?.path}`}>
                      <p
                        className={`${
                          matchRoute(element?.path)
                            ? "text-yellow-25"
                            : "text-richblack-25"
                        }`}>
                        {element?.title}
                      </p>
                    </Link>
                  )}
                </li>
              );
            })}
          </ul>
        </nav>

        {/* Login/signup/dashboard */}
        <div className="flex gap-x-4 items-center">
          {user && user?.accountType !== "Instructor" && (
            <Link to="/dashboard/cart" className="relative flex items-center gap-x-2 justify-center text-center text-richblack-100">
              <AiOutlineShoppingCart />
              {totalItems > 0 && <span>{totalItems}</span>}
            </Link>
          )}
          {token === null && (
            <Link to="/login">
              <button className="border border-richblack-700 text-richblack-100 bg-richblack-800 px-4 py-2 max-[450px]:px-2 rounded-lg">
                Log in
              </button>
            </Link>
          )}
          {token == null && (
            <Link to="/signup">
              <button className="border border-richblack-700 text-richblack-100 bg-richblack-800 px-4 py-2 rounded-lg">
                Sign up
              </button>
            </Link>
          )}
          {
            token !== null
           && 
           <ProfileDropDown/>
          }
        </div>
      </div>
    </div>
  );
}

export default Navbar;